var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wordcloud"},[_c('div',{staticClass:"title"},[_vm._v("搜索热词")]),_c('div',{ref:"wordcloud",staticClass:"wordcloud"})])}
var staticRenderFns = []

export { render, staticRenderFns }